/**
 * Persistent house-ad slot in the cabinet gallery footer (sc-6959).
 *
 * Thin shim over the ad manager (../ads/manager.ts). Unlike the in-game slot
 * this one has no reveal delay — the gallery is chrome, not gameplay, so the
 * banner is present whenever the cabinet is in select mode. Entitled players
 * get no banner (the manager gates it). While a game plays the #play-layer
 * overlay covers the footer, so the rotation tick is paused (no impression
 * logged for a hidden bar).
 *
 * cartridgeId is null here — the footer slot isn't tied to a cartridge. Since
 * the manager's banner-cartridge allowlist only constrains non-null ids, the
 * footer always qualifies; the paying-user gate still applies.
 */

import { getAdManager } from '../ads/manager.js';

const TICK_MS = 1_000;

export function mountCabinetAd(): void {
  const host = document.getElementById('cabinet-ad');
  if (!(host instanceof HTMLElement) || host.dataset.mounted === '1') return;
  host.dataset.mounted = '1';

  const handle = getAdManager().mountBanner(host, 'cabinet-footer', null);
  if (!handle) return; // ads off, or entitled ⇒ no footer banner

  // Drive rotation on a coarse interval instead of rAF — the footer isn't a
  // game loop. Skip ticks while a game is playing: the #play-layer overlay
  // covers the footer, so there's no one to show a swap to.
  window.setInterval(() => {
    const playLayer = document.getElementById('play-layer');
    if (playLayer && !playLayer.hidden) return;
    handle.tick(TICK_MS);
  }, TICK_MS);
}
